import { Fragment } from "react";
import {
  PortableText,
  type PortableTextBlockComponent,
} from "@portabletext/react";

import { richTextComponent } from "@/sanity/sanityPortableText";
import type { MentorCopy } from "@/sanity/pages/PageMentorTemplate";

const inlineBlock: Record<string, PortableTextBlockComponent> = {
  normal: ({ children }) => <Fragment>{children}</Fragment>,
  h1: ({ children }) => <Fragment>{children}</Fragment>,
  h2: ({ children }) => <Fragment>{children}</Fragment>,
  h3: ({ children }) => <Fragment>{children}</Fragment>,
};

export default function MentorText({
  value,
  paragraphs = false,
}: {
  value?: MentorCopy;
  paragraphs?: boolean;
}) {
  if (!Array.isArray(value)) return value ?? null;
  return (
    <PortableText
      value={value}
      components={{
        ...richTextComponent,
        block: paragraphs
          ? {
              ...inlineBlock,
              normal: ({ children }) => (
                <p className="m-0 text-inherit [font-size:inherit] [line-height:inherit]">
                  {children}
                </p>
              ),
            }
          : inlineBlock,
      }}
    />
  );
}
